import React, { useState, useContext, useEffect } from 'react';
import StudentNav from '../Navbars/StudentNav';
import AdminNav from '../Navbars/AdminNav';
import TeacherNav from '../Navbars/TeacherNav';
import GuestNav from '../Navbars/GuestNav';
import Footer from '../Footer';
import './AdminRegisterInCourse.css';
import { UserContext } from '../UserContext';
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import Select from 'react-select';

const AdminRegisterInCourse = () => {
  const [discount, setDiscount] = useState(['10% Off', '20% Off', '30% Off']);

  function Registration({ RegistrationCourse, classIDs, assignedClass_id, assignedClassID }) {
    // console.log("RegistrationCourse:",RegistrationCourse)
    // console.log("assignedClass_id:",assignedClass_id)
    // console.log("assignedClassID:",assignedClassID)
    const uniqueClassIDs = [];
    const filtered_ClassIDs = classIDs.filter((CID) => {
      if (!uniqueClassIDs.hasOwnProperty(CID.Class_id)) {
        uniqueClassIDs[CID.Class_id] = CID;
      }
    });
    // console.log(uniqueClassIDs.CL)
    const filteredClassID = classIDs.filter((CID) => uniqueClassIDs[CID.Class_id].Class_id === CID.Class_id);



    const [assignedClass, setAssignedClass] = useState(assignedClass_id);
    const [assignedTeacherNames, setAssignedTeacherNames] = useState(new Set());
    const [CS, setCS] = useState('');

    var assignedClassObject = classIDs.find((CID) => CID.Class_id === assignedClass);

    // console.log("assignedClass:",assignedClass)
    useEffect(() => {

      if (assignedClass) {
        console.log("classIDs:", classIDs)
        const matchingClass = classIDs.find((CID) => CID.Class_id == assignedClass);
        console.log("matchingClass:", matchingClass)

        if (matchingClass) {
          const classID = matchingClass.ClassID;

          // Regular expression pattern to match the schedule format (day-time)
          const scheduleRegex = /(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)-\d{1,2}:?\d{2}\s*[AaPpMm]{2}/g;

          // Extracting schedule from ClassID using regex
          const extractedSchedule = classID.match(scheduleRegex);

          if (extractedSchedule && extractedSchedule.length > 0) {
            // Extracted schedule will be something like ["Tuesday-6:00 pm"]
            const schedule = extractedSchedule; // Take the first match

            // Now you can set this schedule to state or use it as needed
            console.log("Extracted schedule:", schedule);
            setCS(schedule);
          } else {
            console.log("Schedule not found in ClassID:", classID);
            // Handle case where schedule pattern is not found
          }

          // Example: Extracting teacher names (assuming firstname and lastname exist in matchingClass)
          const teacherName = `${matchingClass.firstname} ${matchingClass.lastname}`;
          setAssignedTeacherNames(new Set([teacherName])); // Using Set to ensure uniqueness
        } else {
          console.log("Matching class not found for assignedClass:", assignedClass);
          // Handle case where matching class is not found in classIDs
        }
      }

    }, [assignedClass, classIDs]);

    const handleClassAssign = (event) => {
      const selectedIndex = event.target.selectedIndex;
      const selectedOption = event.target.options[selectedIndex];
      const cidValue = selectedOption.dataset.cid;
      // console.log(cidValue)

      const newClassType = event.target.value;
      updateAssignedClass(newClassType);
      setAssignedClass(newClassType);
      const matchingClasses = classIDs.filter((CID) => CID.Class_id == newClassType);

      // Extract teacher names from matching classes
      const teacherNames = matchingClasses.map((classObj) => `${classObj.firstname} ${classObj.lastname}`);

      // Update the assigned teacher names state variable
      setAssignedTeacherNames(teacherNames);
      // console.log("ClassIDs",classIDs)
      // assignedClassObject = classIDs.filter((CID) => CID.Class_id == newClassType);
      // console.log("Clid",newClassType)
      // console.log('assignedClassObject:',assignedClassObject)
    };

    const updateAssignedClass = (newClassType) => {
      const User_id = queryParams.get('User_id');
      // console.log("ParamUserId:",ParamUserId)
      // console.log("assignedClass_id:",assignedClass_id)
      axios.put(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/updateStdAssignedClass`, { User_id, assignedClass_id, newClassType })
        .then((response) => {
          // setClassData(response.data.updatedClassData);
          toast.success('Class Successfully Updated.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 500,
          });
          window.location.reload();
        })
        .catch((error) => {
          console.error('Error updating class data:', error);
        });
    };

    return (
      <>
        {RegistrationCourse.StatusComplete == 1 &&
          <tr className='CourseRegistrationTable-tr'>
            <td className='CourseRegistrationTable-td'>
              {RegistrationCourse.firstname} {RegistrationCourse.lastname}
            </td>
            <td className='CourseRegistrationTable-td'>{RegistrationCourse.coursename}</td>
            <td className='CourseRegistrationTable-td'>{RegistrationCourse.RegistrationDate}</td>
            <td className='CourseRegistrationTable-td'> <b>{RegistrationCourse.Currency}</b></td>
            <td className='CourseRegistrationTable-td'>
              {RegistrationCourse.Discount_id}
            </td>

            <td className="CourseRegistrationTable-td">
              {RegistrationCourse.PaymentType}
            </td>

            <td className="CourseRegistrationTable-td">
              {RegistrationCourse.ClassType}
            </td>

            <td className='CourseRegistrationTable-td'>{RegistrationCourse.SchedulePreferenceDay}
              - {RegistrationCourse.SchedulePreferenceTime}</td>
            <td className='CourseRegistrationTable-td'>
              <select
                name="discount"
                id="discount-code"
                className='CourseRegistrationSelect'
                value={assignedClass}
                onChange={handleClassAssign}
              >
                <option value={''} >Select Class</option>
                {uniqueClassIDs.map((CID) => {
                  if (RegistrationCourse.Course_id === CID.Course_id) {
                    return (
                      <option key={CID.Class_id} value={CID.Class_id} data-cid={CID.ClassID}>
                        {CID.ClassID} ({CID.ClassDay} {CID.ClassTime})
                      </option>
                    );
                  }
                  return null;
                })}
              </select>
            </td>

            <td className='CourseRegistrationTable-td' key={filteredClassID?.Class_id} value={filteredClassID?.Class_id}>
              {assignedTeacherNames.size > 0 ? (
                <p className="teacher-name">{Array.from(assignedTeacherNames).join(', ')}</p>
              ) : (
                <p className="no-teacher">No teachers assigned</p>
              )}
            </td>

            <td className='CourseRegistrationTable-td'>
              <div className="class-schedule-info">
                {CS}
              </div>
            </td>
          </tr>
        }
      </>
    );
  };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ParamUsername = queryParams.get('username');
  const ParamUserId = queryParams.get('User_id');

  const [selectedCourse, setSelectedCourse] = useState(null);
  const [courseType, setCourseType] = useState('One-on-One');
  const [paymentType, setPaymentType] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [fee, setFee] = useState('');
  const [discount_, setDiscount_] = useState('');
  const [registrations, setRegistrations] = useState([]);

  const [discounts, setDiscounts] = useState([]);


  const courseTypes = ['One-on-One', 'Group'];

  const paymentTypes = ['Monthly', 'Upfront'];

  const [courses, setCourses] = useState([]);
  const [classes, setClasses] = useState([]);
  const [assignedClasses, setAssignedClasses] = useState([]);
  const [studentRegisteredCourses, setStudentRegisteredCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);




  const { isAdmin, isTeacher, isStudent, isGuest, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  async function fetchDiscounts() {
    try {
      const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getDiscounts`);
      const discount = response.data.discounts;
      setDiscounts(discount);
      // return discounts;
    } catch (error) {
      console.error('Error fetching data from the API:', error);
      return [];
    }
  }
  const fetchStudentCourses = () => {

    axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentRegisteredCourses/${ParamUserId}`)
      .then(response => {
        const data = response.data;
        // console.log(userData);
        const formattedData = data.StudenRsgCourses.map(courseData => ({
          ...courseData,
          RegistrationDate: new Date(courseData.RegistrationDate).toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          })
        }));
        setStudentRegisteredCourses(formattedData);
        setCourseIDs(data.uniqueCourseIDs);

      })
      .catch(error => {
        console.log('Error fetching user:', error);
        // Handle the error as needed
      });
  }
  useEffect(() => {
    const fetchData = async () => {
      await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
        credentials: 'include',
      }).then(response => {
        //  console.log("Response:",response);
        response.json().then(userInfo => {
          //  console.log("userinfo:",userInfo);
          setUserInfo(userInfo);
          //  fetchAllCourses();
          loadCourses();
          fetchAllClasses();
          fetchStudentAssignedClasses();
          //  console.log("assignedClasses:",assignedClasses)
          //  fetchStudentCourses();
          //  console.log(courses);

          if (userInfo?.usertype) {
            const uType = userInfo?.usertype;
            setUserRole(uType);
          }
          const uname = userInfo?.username;
          const avatar = userInfo?.avatar; // Store the avatar in a separate variable
          //  console.log("Uname Admin Register", uname);
          //  console.log("Avatar in: ", avatar);

        })
          .catch(err => console.log("Error in useeffect:", err))
      });
    }
    fetchStudentCourses();
    fetchDiscounts();
    fetchData();
  }, [isAdmin, isTeacher, isStudent, isGuest]);


  const [CourseIDs, setCourseIDs] = useState([]);
  const [ClassIds, setClassIDs] = useState([]);

  //  useEffect(() => {
  //     fetchStudentCourses(); 
  //       fetchDiscounts();
  //   }, []);
  const loadCourses = async () => {
    await fetchAllCourses();
    setLoadingCourses(false);
  };


  // useEffect(() => {
  //   // Simulate loading time

  //   // loadCourses();
  // }, [courses]);

  useEffect(() => {
    fetchClassIDs(CourseIDs);

  }, [studentRegisteredCourses]);
  const onLogin = (usertype) => {

    setUserRole(usertype);
  };
  const navigate = useNavigate();

  async function onLogout() {
    console.log("inside Onlogout.");
    await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: 'include',
      method: 'POST',
    });
    setUserInfo(null);
    console.log("navigating");
    navigate('/');
    // console.log("navigated");
    setUserRole('guest');
  }


  const fetchAllCourses = () => {
    // Fetch all courses
    // axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentAndClasses?UserId=${ParamUserId}`)
    axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStdExcludedCourses?User_id=${ParamUserId}`)
      .then(response => {
        const coursesData = response.data.courses;
        setCourses(coursesData);
      })
      .catch(error => {
        console.log('Error fetching courses:', error);
        // Handle the error as needed
      });
  }
  const fetchAllClasses = () => {
    // Fetch all courses
    axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getAllClasses`)
      .then(response => {
        const classesData = response.data.classes;
        setClasses(classesData);
      })
      .catch(error => {
        console.log('Error fetching courses:', error);
        // Handle the error as needed
      });
  }

  const fetchStudentAssignedClasses = () => {
    console.log('fetchStudentAssignedClasses():')
    axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentAndClasses?UserId=${ParamUserId}`)
      .then(response => {
        const classesData = response.data.classes;
        console.log('classesData:', classesData)
        setAssignedClasses(classesData);
      })
      .catch(error => {
        console.log('Error fetching student and classes:', error);
      });
  };

  const fetchClassIDs = async (courseIds) => {
    try {
      // console.log("in fetchClassIDs,",courseIds)
      const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getClassIDs/${courseIds}`);
      const data = response.data;
      console.log('dataaaa->classes:', data)
      setClassIDs(data.classIDs);
    } catch (error) {
      console.log(error);
    }
  };


  const getClassById = (classId) => {
    console.log("classId,classes:", classId, classes)
    const foundClass = classes.find((cls) => cls.Class_id === parseInt(classId));
    console.log("foundClass", foundClass)
    return foundClass ? foundClass.Class_id : '';
  };

  const handleCourseChange = (selectedOption) => {
    const selectedCourse = courses.find((course) => course.Course_id === (selectedOption ? selectedOption.value : null));
    setSelectedCourse(selectedCourse);
  };

  const handleCourseTypeChange = (event) => {
    const { value } = event.target;
    setCourseType(value);
  };

  const handlePaymentTypeChange = (event) => {
    const { value } = event.target;
    setPaymentType(value);
  };

  const handleClassChange = (event) => {
    const { value } = event.target;
    setSelectedClass(value);
  };

  const handleFeeChange = (event) => {
    const { value } = event.target;
    setFee(value);
  };

  const handleDiscountChange = (event) => {
    const { value } = event.target;
    const selectedDiscount = discounts.find((discount) => discount.Discount_id === parseInt(value));
    setDiscount_(selectedDiscount);
  };

  const handleRegistration = () => {
    const now = new Date();
    const newRegistration = {
      Course_id: selectedCourse ? selectedCourse.Course_id : '',
      courseType,
      paymentType,
      fee,
      discountID: discount_ ? discount_.Discount_id : null, // This will handle empty discount
      Class: getClassById(selectedClass),
      registrationDate: now.toISOString().slice(0, 19).replace('T', ' '),
      SchedulePreferenceDay: '',
      SchedulePreferenceTime: '',
      StatusComplete: 1,
    };


    // Check for empty fields
    const requiredFields = ['Course_id', 'courseType', 'paymentType', 'fee', 'Class'];
    const emptyField = requiredFields.find(field => !newRegistration[field]);

    if (emptyField) {
      toast.error(`Please fill in the ${emptyField} field`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }

    setRegistrations([...registrations, newRegistration]);

    // Make an Axios POST request to the API
    axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveStudent_Studentcourses/${ParamUserId}`, newRegistration)
      .then(response => {
        fetchAllCourses();
        fetchStudentAssignedClasses();
        fetchStudentCourses();
        // Show success message
        toast.success('Registered Successfully!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      })
      .catch(error => {
        // Handle errors here
        console.error('API Error:', error);
      });

    setSelectedCourse('');
    setCourseType('');
    setPaymentType('');
    setSelectedClass('');
    setFee('');
    setDiscount('');
  };

  const username = userInfo?.username;
  const _avatar_ = userInfo?.avatar;

  return (
    <>
      {/* Navbar */}
      {username && (
        <>
          {isAdmin && <AdminNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isTeacher && <TeacherNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isStudent && <StudentNav username={username} avatar={_avatar_} onLogout={onLogout} />}
        </>
      )}
      {!username && (
        <>
          {isGuest && <GuestNav onLogin={onLogin} />}
        </>
      )}
      <div className='AdminRegisterNewHeader'>
        <div className='HeaderTitleSection'>
          <h1 className='MainTitleText'>Register in Course</h1>
          <p className='SubTitleText'>Assigning new course to <span className='StudentHighlight'>{ParamUsername}</span></p>
        </div>
      </div>

      <div className='RegisterPageContent'>
        <div className='RegistrationFormCard'>
          <div className='CardHeader'>
            <h3>Course Registration Form</h3>
          </div>
          <div className='VerticalForm'>
            <div className="input-field-group">
              <label>Select Course (Searchable)</label>
              <Select
                className="FormDropdownLargeSelect"
                classNamePrefix="react-select"
                options={courses
                  .sort((a, b) => a.coursename.localeCompare(b.coursename))
                  .map(course => ({
                    value: course.Course_id,
                    label: course.coursename
                  }))
                }
                isSearchable={true}
                placeholder="Type to search course..."
                value={selectedCourse ? { value: selectedCourse.Course_id, label: selectedCourse.coursename } : null}
                onChange={handleCourseChange}
                isLoading={loadingCourses}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: '52px',
                    borderRadius: '12px',
                    border: '2px solid #e2e8f0',
                    boxShadow: state.isFocused ? '0 0 0 4px rgba(3, 180, 198, 0.1)' : 'none',
                    borderColor: state.isFocused ? '#03b4c6' : '#e2e8f0',
                    '&:hover': {
                      borderColor: state.isFocused ? '#03b4c6' : '#cbd5e1',
                    }
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    padding: '0 20px',
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: '#94a3b8',
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: '#1e293b',
                    fontSize: '16px',
                  }),
                  input: (base) => ({
                    ...base,
                    color: '#1e293b',
                  }),
                  menu: (base) => ({
                    ...base,
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                  })
                }}
              />
            </div>

            <div className="input-field-group">
              <label>Course Type</label>
              <select className='FormDropdownLarge'
                required
                value={courseType}
                onChange={handleCourseTypeChange}
              >
                {courseTypes.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

            <div className="input-field-group">
              <label>Payment Type</label>
              <select className='FormDropdownLarge'
                required
                value={paymentType}
                onChange={handlePaymentTypeChange}>
                <option value=''>Select Payment Type</option>
                {paymentTypes.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

            <div className="input-field-group">
              <label>Select Class</label>
              <select className='FormDropdownLarge'
                required
                value={selectedClass}
                onChange={handleClassChange}
              >
                <option value=''>Select Class</option>
                {selectedCourse &&
                  classes
                    .filter((cls) => (cls.Course_id === parseInt(selectedCourse.Course_id) && courseType == cls.ClassType))
                    .map((cls) => (
                      <option key={cls.Class_id} value={cls.Class_id}>
                        {cls.ClassID}
                      </option>
                    ))}
              </select>
            </div>

            <div className="input-field-group">
              <label>Fee Details</label>
              <input className='FormInputLarge' type='text' required value={fee}
                onChange={handleFeeChange} placeholder='Fee (e.g. USD 500 / PKR 24500)' />
            </div>

            <div className="input-field-group">
              <label>Discount Option</label>
              <select className='FormDropdownLarge'
                value={discount_ ? discount_.Discount_id.toString() : ''}
                onChange={handleDiscountChange}>
                <option value=''>Select Discount</option>
                {discounts.map((discount) => (
                  <option key={discount.Discount_id} value={discount.Discount_id}>
                    {discount.discountpercentage}%
                  </option>
                ))}
              </select>
            </div>

            <div className='RegisterButtonWrapper'>
              <button className='ModernRegisterButton' type='submit' onClick={handleRegistration}>
                Register {ParamUsername}
              </button>
            </div>
          </div>
        </div>

        <div className='RegistrationPreviewCard'>
          <div className='CardHeader'>
            <h3>Registration History / Preview</h3>
          </div>
          <div className="ModernTableWrapper">
            <table className='ModernRegistrationTable'>
              <thead>
                <tr>
                  <th>Student</th>
                  <th>Course</th>
                  <th>Date</th>
                  <th>Fee</th>
                  <th>Disc</th>
                  <th>Payment</th>
                  <th>Type</th>
                  <th>Pref Day/Time</th>
                  <th>Class ID</th>
                  <th>Teacher</th>
                  <th>Schedule</th>
                </tr>
              </thead>
              <tbody>
                {studentRegisteredCourses.map((RegistrationCourse, index) => {
                  const matchingClass = assignedClasses.find(cls => cls.Course_id === RegistrationCourse.Course_id);
                  return (
                    <Registration key={index} RegistrationCourse={RegistrationCourse}
                      classIDs={ClassIds}
                      filteredClassID={matchingClass}
                      CS={matchingClass ? matchingClass.ClassDay + '-' + matchingClass.ClassTime : ''}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdminRegisterInCourse;
